
const queryMixin = {
  methods: {
    addFixedParams(query) {
      const params = {
        riderMobile: this.$route.query.riderMobile || this.$route.query.mobile,
        riderId: this.$route.query.riderId || this.$route.query.riderid,
        city: this.$route.query.city,
        dltoken: this.$route.query.dltoken,
        PhoneType: this.$route.query.PhoneType,
        riderName: this.$route.query.riderName
      };

      const mergedQuery = {
        ...query,
        ...params
      };

      const filteredQuery = {};
      for (const key in mergedQuery) {
        if (mergedQuery.hasOwnProperty(key)) {
          filteredQuery[key] = mergedQuery[key];
        }
      }

      return filteredQuery;
    }
  }
};

export default queryMixin;



// WEBPACK FOOTER //
// ./src/utils/routerPushQuery.js